<div class="font-bold mb-3" i18n>Does your network support a region or a country that mandates a regulatory emergency call (eCall)?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="updateRegulatorySupport()"
          name="regulatoryECallSupport.supportECall"
          inputId="regulatoryECallSupport.supportECall#1"
          value="1"
          [(ngModel)]="profileValues.regulatoryECallSupport.supportECall"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="regulatoryECallSupport.supportECall#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="updateRegulatorySupport()"
          name="regulatoryECallSupport.supportECall"
          inputId="regulatoryECallSupport.supportECall#0"
          value="0"
          [(ngModel)]="profileValues.regulatoryECallSupport.supportECall"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="regulatoryECallSupport.supportECall#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
<div *ngIf="+profileValues.regulatoryECallSupport.supportECall === 1" class="font-bold mb-3" i18n>
  Industry standard specifies two ways of supporting eCall. Please select one of the following:
</div>
<div *ngIf="+profileValues.regulatoryECallSupport.supportECall === 1" class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="updateRegulatorySupport()"
          name="regulatoryECallSupport.eCallType"
          inputId="regulatoryECallSupport.eCallType#1"
          value="1"
          [(ngModel)]="profileValues.regulatoryECallSupport.eCallType"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="regulatoryECallSupport.eCallType#1" i18n>eCall Only</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="updateRegulatorySupport()"
          name="regulatoryECallSupport.eCallType"
          inputId="regulatoryECallSupport.eCallType#2"
          value="2"
          [(ngModel)]="profileValues.regulatoryECallSupport.eCallType"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="regulatoryECallSupport.eCallType#2" i18n>eCall + Normal</label>
      </td>
    </tr>
  </table>
</div>
